"use client";
import { daysToMs } from "@/utils/date/dayToMs";
import { lang } from "@/utils/lang/langType";
import { setCookie } from "cookies-next";

export default function SetCookies({ lang }: { lang: lang }) {
  setCookie("lang", lang, { maxAge: daysToMs(1000) });
  return <></>;
}
